import {
  gtagToDataLayer,
  isConsoleDocument,
  isExternalTrackingBlockedPath,
  isProductionTrackingHost,
} from './productionTracking';

let configuredGtag = null;

const safeReferrerConfig = () => {
  try {
    if (!document.referrer) return {};
    const referrer = new URL(document.referrer);
    return isExternalTrackingBlockedPath(referrer.pathname, referrer.search)
      ? { page_referrer: '' }
      : {};
  } catch (_) {
    return { page_referrer: '' };
  }
};

/**
 * Initialize on a safe production route, including after an excluded SPA entry.
 * This queues commands; it is not proof that Google received them.
 */
export const initializeGoogleTag = () => {
  if (!isProductionTrackingHost() || isConsoleDocument() || isExternalTrackingBlockedPath()) return false;
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const googleAdsId = process.env.REACT_APP_GOOGLE_ADS_ID;
  const primaryId = measurementId || googleAdsId;
  if (!primaryId) return false;

  try {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = gtagToDataLayer;
    }
    if (configuredGtag === window.gtag) return true;

    const existing = document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js?id="]');
    if (!existing) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${primaryId}`;
      document.head.appendChild(script);
    }

    window.gtag('js', new Date());
    const referrerConfig = safeReferrerConfig();
    // GTM owns page views; keep the app tag from duplicating them.
    if (measurementId) {
      window.gtag('config', measurementId, { send_page_view: false, ...referrerConfig });
    }
    if (googleAdsId) {
      const domains = (process.env.REACT_APP_GOOGLE_ADS_LINKER_DOMAINS || '')
        .split(',')
        .map((domain) => domain.trim())
        .filter(Boolean);
      window.gtag('config', googleAdsId, {
        ...(domains.length ? { linker: { domains } } : {}),
        ...referrerConfig,
      });
    }
    configuredGtag = window.gtag;
    return true;
  } catch (_) {
    return false;
  }
};

export const __resetGoogleTagForTests = () => {
  configuredGtag = null;
};
